import apiService from './api';

class ChatService {
  /**
   * Get user's chat rooms
   */
  async getChatRooms() {
    return apiService.get('/chat/rooms');
  }

  /**
   * Get a specific chat room with messages
   */
  async getChatRoom(roomId) {
    return apiService.get(`/chat/rooms/${roomId}`);
  }

  /**
   * Create a new chat room
   */
  async createChatRoom(data) {
    return apiService.post('/chat/rooms', data);
  }

  /**
   * Update a chat room
   */
  async updateChatRoom(roomId, data) {
    return apiService.put(`/chat/rooms/${roomId}`, data);
  }

  /**
   * Delete a chat room
   */
  async deleteChatRoom(roomId) {
    return apiService.delete(`/chat/rooms/${roomId}`);
  }

  /**
   * Get messages for a chat room
   */
  async getMessages(roomId, options = {}) {
    const params = new URLSearchParams();
    if (options.limit) params.append('limit', options.limit);
    if (options.before_id) params.append('before_id', options.before_id);
    
    const queryString = params.toString();
    const endpoint = `/chat/rooms/${roomId}/messages${queryString ? `?${queryString}` : ''}`;
    return apiService.get(endpoint);
  }

  /**
   * Send a message to a chat room
   */
  async sendMessage(roomId, message, type = 'text') {
    return apiService.post(`/chat/rooms/${roomId}/messages`, {
      message,
      type,
    });
  }

  /**
   * Get peers (users) in a chat room
   */
  async getPeers(roomId) {
    return apiService.get(`/chat/rooms/${roomId}/peers`);
  }

  /**
   * Mark messages as read
   */
  async markMessagesAsRead(roomId) {
    return apiService.post(`/chat/rooms/${roomId}/mark-read`);
  }

  /**
   * Get unread message counts
   */
  async getUnreadCounts() {
    return apiService.get('/chat/unread-counts');
  }

  /**
   * Get peer-to-peer chat info
   */
  async getPeerToPeerChatInfo(userId) {
    return apiService.get(`/chat/p2p/${userId}`);
  }

  /**
   * Send peer-to-peer message
   */
  async sendPeerToPeerMessage(userId, message, type = 'text') {
    return apiService.post(`/chat/p2p/${userId}/message`, {
      message,
      type,
    });
  }

  /**
   * Start peer-to-peer chat
   */
  async startPeerToPeerChat(userId) {
    return apiService.post(`/chat/p2p/${userId}/start`);
  }

  /**
   * Update user status (last seen and online status)
   * Fails silently if backend is not available
   */
  async updateUserStatus(isOnline = true) {
    try {
      return await apiService.post('/chat/user/status', {
        is_online: isOnline,
      });
    } catch (error) {
      // Fail silently - user status updates are not critical
      // Backend might be down or not running
      console.debug('Failed to update user status (non-critical):', error.message);
      return { success: false, error: error.message };
    }
  }
}

export default new ChatService();

